module.exports = __webpack_public_path__ + "img/lunbo01_03.c382c9b2.png";